import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
// import { hasPermission } from "../../../utils/commonfunction";
import logo from "../../../assets/admin/img/logo.png";
import { useTranslation } from "react-i18next";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    $("body").removeClass("main-sidebar-open");
  };

  return (
    <div className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y" id="app_sidebar" onMouseEnter={hoverSidebar} onMouseLeave={removeHoverSidebar}>
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          {/* <img
            src={logo}
            className="header-brand-img icon-logo admin-logo"
            alt="logo"
            style={{ height: "1.6rem", width: "4rem" }}
            id="logo_short"
          /> */}
          <img
            src={logo}
            // className="header-brand-img desktop-logo admin-logo rounded"
            style={{ height: "50px", width: "50px",borderRadius:"6px" }}
            alt="logo"
            id="logo_full"
          />
        </a>
      </div>
      {/* Dashboard section start */}
      <div className="main-sidebar-body">
        <ul className="nav">
          <li className={"nav-item" + (loc.pathname === "/admin/dashboard" ? " active" : "")}>
            <Link className="nav-link" to="/admin/dashboard">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_dashboard")}</span>
            </Link>
          </li>

          {/* Dashboard section end */}
          {/* Customer section start */}
          <li className={"nav-item" + (loc.pathname.startsWith("/admin/customerManagement/customers") ? " active" : "")}>
            <Link className="nav-link" to="/admin/customerManagement/customers/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-users sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Customer Management")}</span>
            </Link>
          </li>

          <li className={`nav-item ` + (loc.pathname.includes("/cms") ? "show active" : "")}>
            <a className="nav-link with-sub submenu" onClick={toggleDropdown} href={"/"}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-edit sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className={`nav-sub-item ${loc.pathname.includes("/cms/pages") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/cms/pages/list/${1}`}>
                  {t("sidebar_link_pages")}
                </Link>
              </li>
              {/* <li
                  className={`nav-sub-item ${loc.pathname.includes("/cms/banner") ? " active" : ""
                    }`}
                >
                  <Link
                    className="nav-sub-link"
                    to={`/admin/cms/banner/list/${1}`}
                  >
                    {t("sidebar_link_banners")}
                  </Link>
                </li> */}
              <li className={"nav-sub-item" + (loc.pathname.includes("/cms/default-email-template") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/cms/default-email-template/list/${1}`}>
                  {t("sidebar_link_email_template")}
                </Link>
              </li>

              <li className={"nav-sub-item" + (loc.pathname.includes("/cms/settings") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/cms/settings`}>
                  {t("sidebar_link_global_settings")}
                </Link>
              </li>
              <li className={"nav-sub-item" + (loc.pathname.includes("/cms/faq") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/cms/faq/list/${1}`}>
                  {t("FAQ")}
                </Link>
              </li>
              <li className={"nav-sub-item" + (loc.pathname.includes("/cms/contactUs") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/cms/contactUs/list/${1}`}>
                  {t("Contact Us")}
                </Link>
              </li>
              <li className={"nav-sub-item" + (loc.pathname.includes("/photoroom-usage") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/photoroom-usage/list/${1}`}>
                  Photoroom Usage
                </Link>
              </li>
            </ul>
          </li>

          {/*  items section  */}
          <li className={"nav-item" + (loc.pathname.startsWith("/admin/itemManagement") ? " active" : "")}>
            <Link className="nav-link" to="/admin/itemManagement/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-clipboard sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_item")}</span>
            </Link>
          </li>

          <li className={"nav-item" + (loc.pathname.startsWith("/admin/outfitManagement") ? " active" : "")}>
            <Link className="nav-link" to="/admin/outfitManagement/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-tshirt sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_outfit")}</span>
            </Link>
          </li>

          {/* Category section start */}
          <li className={"nav-item" + (loc.pathname.startsWith("/admin/category") ? " active" : "")}>
            <Link className="nav-link" to="/admin/category/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-table sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_category")}</span>
            </Link>
          </li>
           <li className={"nav-item" + (loc.pathname.startsWith("/admin/subcategory") ? " active" : "")}>
            <Link className="nav-link" to="/admin/subcategory/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-list sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_sub_category")}</span>
            </Link>
          </li>
          {/* category section end */}
          {/* Brand section start */}
          <li className={"nav-item" + (loc.pathname.startsWith("/admin/brand") ? " active" : "")}>
            <Link className="nav-link" to="/admin/brand/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-tags sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_brand")}</span>
            </Link>
          </li>
          {/* Brand section end */}
          {/* Sub Category section start */}
         
          {/* Sub category section end */}
          {/* Cms section start */}
          {/* {hasPermission("/admin/cms") ? ( */}

          {/* // ) : null} */}
          {/* Cms section end */}

          {/* Posts section start */}
          <li className={"nav-item" + (loc.pathname.startsWith("/admin/posts") ? " active" : "")}>
            <Link className="nav-link" to="/admin/posts/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-clipboard sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Posts")}</span>
            </Link>
          </li>

          {/* Reported Posts section start */}
          <li className={"nav-item" + (loc.pathname.startsWith("/admin/reportedPosts") ? " active" : "")}>
            <Link className="nav-link" to="/admin/reportedPosts/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-flag sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Reported Posts")}</span>
            </Link>
          </li>

           {/* <li className={"nav-item" + (loc.pathname.startsWith("/admin/backgroundRemoval") ? " active" : "")}>
            <Link className="nav-link" to="/admin/backgroundRemoval/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-flag sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Background Removal")}</span>
            </Link>
          </li> */}
          {/* Reported Posts section end */}

          {/* testimonial management section end */}
          {/* <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/testimonial-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/testimonial-management/testimonial/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-comment-dots sidemenu-icon"></i>
                <span className="sidemenu-label">
                {t("sidebar_link_testimonials")}
                </span>
              </Link>
            </li> */}
          {/* testimonial management section end */}

          {/* Subscriptions section start */}
          <li className={`nav-item ` + (loc.pathname.includes("/admin/subscriptionManagement") || loc.pathname.includes("/admin/userSubscriptions") || loc.pathname.includes("/admin/transactions") ? "show active" : "")}>
            <a className="nav-link with-sub submenu" onClick={toggleDropdown} href={"/"}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-dollar sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_subscribe")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className={`nav-sub-item ${loc.pathname.includes("/admin/subscriptionManagement") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/subscriptionManagement/list/1`}>
                  {t("sidebar_link_subscription_plans")}
                </Link>
              </li>
              <li className={`nav-sub-item ${loc.pathname.includes("/admin/userSubscriptions") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/userSubscriptions/list/1`}>
                  {t("sidebar_link_user_subscriptions")}
                </Link>
              </li>
              <li className={`nav-sub-item ${loc.pathname.includes("/admin/transactions") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/transactions/list/1`}>
                  {t("sidebar_link_transactions")}
                </Link>
              </li>
            </ul>
          </li>
          {/* Subscriptions section end */}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
